module.exports = __webpack_public_path__ + "img/10.2b7b8605.png";